import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

type ProtectedRouteProps = {
  allowedRoles?: string[];
};

// Ver informe "LYNX — Fase 1.2.9": ruta de la pantalla obligatoria de
// cambio de contraseña — única excepción al bloqueo de abajo, para no
// generar un loop de redirects contra sí misma.
export const FORCED_PASSWORD_CHANGE_PATH = "/cambiar-password";

export default function ProtectedRoute({
  allowedRoles = [],
}: ProtectedRouteProps) {
  const { isAuthenticated, rol, mustChangePassword } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Ver informe "LYNX — Fase 1.2.9": bloquea CUALQUIER ruta protegida
  // (todos los roles pasan por acá) mientras la contraseña vigente no
  // cumpla la política — nunca se llega a navegar al resto del sistema con
  // una contraseña insegura, sea cual sea el rol.
  if (mustChangePassword && location.pathname !== FORCED_PASSWORD_CHANGE_PATH) {
    return <Navigate to={FORCED_PASSWORD_CHANGE_PATH} replace />;
  }

  if (allowedRoles.length > 0) {
    const normalizedRole = String(rol || "").toUpperCase();
    const isAllowed = allowedRoles
      .map((role) => role.toUpperCase())
      .includes(normalizedRole);

    if (!isAllowed) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
}